import { ILogo } from "./Logo.interface";
import LogoImg from "./../../shared/assets/imgs/logo.svg";
import LogoWhiteImg from "./../../shared/assets/imgs/logo_white.svg";

function Logo({ isWhite, className }: ILogo) {
    return <img className={`logo ${className ?? ""}`} src={isWhite ? LogoWhiteImg : LogoImg} alt="Prosperh" />;
}

export default Logo;
